import { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { BrandLogo } from '../ui/BrandLogo'

export function LegalLayout({ title, updated, children }: { title: string; updated: string; children: ReactNode }) {
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-200">
      <header className="border-b border-zinc-800">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-6 py-5">
          <Link to="/" className="text-white no-underline">
            <BrandLogo />
          </Link>
          <Link to="/" className="text-sm text-zinc-400 hover:text-white">
            ← Home
          </Link>
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-6 py-12">
        <h1 className="text-3xl font-extrabold text-white">{title}</h1>
        <p className="mt-2 text-sm text-zinc-500">Last updated {updated}</p>
        <div className="prose-invert mt-8 space-y-5 text-[15px] leading-relaxed text-zinc-300 [&_h2]:mt-8 [&_h2]:text-xl [&_h2]:font-bold [&_h2]:text-white [&_a]:text-fuchsia-400">
          {children}
        </div>
      </main>
    </div>
  )
}
